"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _http = _interopRequireWildcard(require("./http"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * 
 * A function that returns a configured instance of the {@link http} module.
 * This function's argument will be used as the default config for the returned instance.
 *
 * Note: This configuration can always be overridden by passing in options manually.
 *
 * @name configureHttp
 * @type Function
 * @param {Object} config - An http configuration object
 * @param {Object} [baseHttp] - An existing http instance to extend with the configuration
 * @returns {Object} A configured http instance
 * 
 * @example
 * 
 * const myHttp = configureHttp({ root: 'http://example.com', mode: 'cors' })
 * 
 * myHttp('/thing', { method: 'GET' }) // A cors request will be made to "http://example.com/thing"
 * 
 * 
 */
function configureHttp(defaults) {
  var baseHttp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _http["default"];
  return function configuredHttp() {
    var options = _http.parseArguments.apply(void 0, arguments);

    return baseHttp(_objectSpread({}, defaults, {}, options));
  };
}

var _default = configureHttp;
exports["default"] = _default;